import { createHeaders, createRequest, throwResErrors } from "./requestUtil";

export const validateMove = (data) => {
	return createRequest()
		.post(`api/strategy/move/validate`, data, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};
